import { TextAreaWithLabel } from '@adotel/components'
import { Divider, Typography } from '@material-ui/core'
import React from 'react'

import { getTranslate } from '../../../../localization'
import { ChangeReserveDetailsInput } from '../../../../types/changeReserveDetails'
import { useStyles } from './styles/index.styles'

type Props = {
  setChangeReserveInput: React.Dispatch<
    React.SetStateAction<ChangeReserveDetailsInput>
  >
}
export default function AddDescription({ setChangeReserveInput }: Props) {
  const classes = useStyles()
  const handleChange = (newValue: any) => {
    setChangeReserveInput((oldState) => ({
      ...oldState,
      description: newValue
    }))
  }

  return (
    <div className={classes.container}>
      <div className={classes.top}>
        <Typography variant="h4" className={classes.blackText}>
          {getTranslate('Add Description')}
        </Typography>
      </div>
      <Divider />
      <div className={classes.bottom}>
        <TextAreaWithLabel
          label={getTranslate('Description')}
          name="Description"
          rows={7}
          noHelperText
          onChange={(event) => {
            handleChange(event.currentTarget.value)
          }}
        />
      </div>
    </div>
  )
}
